import Subtitle from "../typography/Subtitle";
import Title from "../typography/Title";
import Description from "../typography/Description";
import iso from "../../assets/ISO27001.png";
import gdpr from "../../assets/gdpr_white.png";
import dpdp from "../../assets/dpdp-white.jpeg";
import {
  ShieldCheckIcon,
  LockKeyIcon,
  EyeIcon,
  PlugsConnectedIcon,
  GearIcon,
} from "@phosphor-icons/react";

const complianceItems = [
  {
    icon: ShieldCheckIcon,
    title: "DPDP Compliant",
    description: "Ready for DPDP compliance",
    logo: dpdp,
  },
  {
    icon: LockKeyIcon,
    title: "ISO 27001",
    description: "International standard for information security management",
    logo: iso,
  },
  {
    icon: EyeIcon,
    title: "GDPR Compliant",
    description: "Full data protection compliance for EU regulations",
    logo: gdpr,
  },
];

const integrations = [
  "Darwinbox",
  "Greenhouse",
  "Lever",
  "Keka HR",
  "Workable",
  "BambooHR",
  "Zoho Recruit",
  "Freshteam",
  "Slack",
  "Microsoft Teams",
  "Google Workspace",
  "LinkedIn",
  "Indeed",
  "Naukri",
  "HireVue",
  "Jira",
  "Salesforce",
  "Oracle HCM",
  "ADP",
  "Rippling",
];

const EnterpriseReady = () => {
  return (
    <>
      {/* Section 1: Compliance & Security */}
      <section className="relative flex h-auto w-screen snap-start snap-always flex-col items-center justify-center overflow-hidden bg-gray-950 px-4 py-12 md:py-16">
        <Subtitle>Enterprise-Ready</Subtitle>
        <Title as="h2" className="mt-4 max-w-screen-md">
          Compliance & Security
        </Title>
        <Description className="mt-4 max-w-screen-sm">
          Enterprise-grade compliance and robust security — so your team can
          deploy with confidence.
        </Description>

        <div className="mx-auto mt-12 grid w-full max-w-screen-lg grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {complianceItems.map((item) => (
            <div
              key={item.title}
              className="flex flex-col gap-4 rounded-xl border border-white/[0.08] bg-gray-800/60 p-5 transition-colors duration-300 hover:border-app-400/20"
            >
              <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-app-400/10">
                  <item.icon
                    size={22}
                    weight="duotone"
                    className="text-app-400"
                  />
                </div>
                <div>
                  <h4 className="font-serif text-base font-medium text-white">
                    {item.title}
                  </h4>
                  <p className="mt-1 font-sans text-sm text-gray-400">
                    {item.description}
                  </p>
                </div>
              </div>
              {item.logo && (
                <div className="flex items-center justify-center border-t border-white/[0.06] pt-4">
                  <img
                    src={item.logo}
                    alt={item.title}
                    className="h-14 object-contain opacity-80"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Section 2: Integrations */}
      <section className="relative flex h-auto w-screen snap-start snap-always flex-col items-center justify-center overflow-hidden bg-gray-900 px-4 py-12 md:py-16">
        <Subtitle>Enterprise-Ready</Subtitle>
        <Title as="h2" className="mt-4 max-w-screen-md">
          Integrations
        </Title>
        <Description className="mt-4 max-w-screen-sm">
          Seamless integrations with 50+ tools to fit right into your existing
          workflow.
        </Description>

        <div className="mx-auto mt-12 flex w-full max-w-screen-md flex-wrap items-center justify-center gap-3">
          {integrations.map((name) => (
            <span
              key={name}
              className="rounded-full border border-white/[0.08] bg-gray-800/60 px-4 py-2 font-sans text-sm text-gray-300 transition-colors duration-300 hover:border-app-400/20 hover:text-white"
            >
              {name}
            </span>
          ))}
          <span className="flex items-center gap-2 rounded-full border border-app-400/30 bg-app-400/10 px-4 py-2 font-sans text-sm text-app-300">
            <GearIcon size={16} weight="duotone" />
            Custom Integrations
          </span>
          <span className="flex items-center gap-2 rounded-full border border-white/[0.08] bg-gray-800/60 px-4 py-2 font-sans text-sm text-gray-300">
            <PlugsConnectedIcon size={16} weight="duotone" />
            and 30+ more
          </span>
        </div>
      </section>
    </>
  );
};

export default EnterpriseReady;
